import PropTypes from 'prop-types';
import * as Styled from './PlanType.styles';
import { Stack } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { BuyPlanComponent } from 'components/BuyPlanComponent/BuyPlanComponent';

export const PlanType = ({ current,productId, productCode }) => {
  return (
    <Stack direction="column" display='flex' alignItems="stretch" >
       {current &&<Stack direction="row" justifyContent='center' alignItems='center' sx={{minHeight:'40px'}}>
            <CheckCircleOutlineIcon/>
            <Styled.H4>Twój bieżacy plan</Styled.H4>
       </Stack>}
       {!current &&<Stack display='flex' alignItems="stretch">
            <BuyPlanComponent productId={productId} productCode={productCode}/>                        
       </Stack>}
    </Stack> 
  );
};

PlanType.propTypes = {
    current: PropTypes.bool   ,
    productCode: PropTypes.string,
    productId: PropTypes.string
};
